import { createSelector } from "@reduxjs/toolkit";

import { AppSelector } from "~/app/store";

import { LanguageCode } from "~/localization_i18n";
import { StoreState } from "~/redux/reducers";

import { selectUsersFulfillmentCenterId } from "./storeSelectors";
import { selectWorkstationSiteFulfillmentCenterId } from "./workstationsSelectors";

export const selectLanguageCode = (state: StoreState) =>
  state.site.languageCode;

export const selectLocale = (state: StoreState): LanguageCode => {
  const languageCode = selectLanguageCode(state);
  return languageCode === "bs" ? "en" : languageCode;
};

export const selectClientConfig = (state: StoreState) =>
  state.site.clientConfig;

export const selectUserMessages = (state: StoreState) =>
  state.site.userMessages;

export const selectSiteFulfillmentCenterId: AppSelector<string | null> =
  createSelector(
    [selectWorkstationSiteFulfillmentCenterId, selectUsersFulfillmentCenterId],
    (siteFulfillmentCenterId, usersFulfillmentCenterId) =>
      siteFulfillmentCenterId
        ? siteFulfillmentCenterId
        : (usersFulfillmentCenterId ?? null)
  );
